<template>
  <div :class="isPc ? 'scan' : ''">
    <img class="scan-help" src="../../assets/images/scan_help.png" :style="{marginRight: (scanHelpShow ? '0' : '-140px'), opacity: (scanHelpShow ? '1' : '0')}">
    <div class="scan-content" :style="{marginLeft: (scanHelpShow ? '0' : '140px')}">
      <IconSwitch :type="'account'"></IconSwitch>
      <Icon style="margin-top: 0;"></Icon>
      <el-collapse-transition>
        <Error v-if="errorShow && $route.query.showTip" :type="'tip'" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
      </el-collapse-transition>
      <Qrcode></Qrcode>
      <Foot :type="'Scan the QR code to sign in'" style="margin-bottom: 45px;" v-on:scanHelp="scanHelp"></Foot>
    </div>
  </div>
</template>

<script>
  import IconSwitch from '../components/Iconswitch'
  import Icon from '../components/Icon'
  import Error from '../components/Error'
  import Qrcode from '../components/Qrcode'
  import Foot from '../components/Foot'
  import { errorFn } from '../common/ErrorMsg.js'
  export default {
    data () {
      return {
        errorShow: true,
        errorMsg: 'To verify your identity, please scan this QRcode with the Crait mobile app',
        account: '', // 输入的账号
        scanHelpShow: false
      }
    },
    components: {
      IconSwitch, Icon, Error, Qrcode, Foot
    },
    props: ['isPc'],
    mounted () {
      // if (this.$route.query.showTip) this.scanHelpShow = true
    },
    methods: {
      getAccount (data) {
        this.account = data
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      scanHelp () {
        this.scanHelpShow = !this.scanHelpShow
      }
    }
  }
</script>

<style lang="scss" scoped>
  // @import '../../assets/css/_mixin.scss';
  .scan {
    // @include white-bg;
    width: 720px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -360px;
    border-radius: 4px;
    margin-top: -210px;
    .scan-content {
      width: 440px;
      // margin-left: 140px;
      float: left;
      transition: all 0.5s;
      padding-top: 50px;
      background: #ffffff;
      min-height: 420px;
    }
    .scan-help {
      margin-top: -10px;
      float: right;
      transition: all 0.5s;
    }
  }
</style>



// WEBPACK FOOTER //
// Scan.vue?0450210e